// extracted by mini-css-extract-plugin
export var deleteIcon = "_om-5";
export var deleteOption = "_om-3";
export var divider = "_om-2";
export var downloadIcon = "_om-4";
export var drawer = "_om-0";
export var drawerFooter = "_om-6";
export var drawerOpen = "_om-1";
export var highlighted = "_om-7";
export var lighterHighlight = "_om-8";